/**
 * Formulaire inline de création rapide d'un To Do (affiché dans la fiche contact).
 */

import React, { useEffect, useState } from "react";
import { createTodo } from "../api/todoApi";
import { getTags, createTag } from "../api/tagApi";
import { getUsers } from "../api/userApi";
import { useAuth } from "../contexts/AuthContext";
import TagSelector from "./TagSelector";

export default function InlineTodoForm({ contactId, onCreated, onCancel }) {
  const { user } = useAuth();
  const [allTags, setAllTags] = useState([]);
  const [users, setUsers] = useState([]);
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    description: "",
    due_date: "",
    stake_level: "",
    urgency_level: "",
    status: "in_progress",
    responsable_user_id: user?.id ? String(user.id) : "",
    tag_ids: [],
  });

  useEffect(() => {
    getTags().then(setAllTags);
    getUsers().then(setUsers);
  }, []);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleCreateTag(label) {
    const tag = await createTag(label);
    setAllTags([...allTags, tag]);
    setForm({ ...form, tag_ids: [...form.tag_ids, tag.id] });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    try {
      await createTodo({
        contact_id: contactId,
        description: form.description,
        due_date: form.due_date || null,
        stake_level: form.stake_level || null,
        urgency_level: form.urgency_level || null,
        status: form.status,
        responsable_user_id: form.responsable_user_id ? Number(form.responsable_user_id) : null,
        tag_ids: form.tag_ids,
      });
      onCreated();
    } catch {
      setError("Erreur lors de la création du To Do.");
    }
  }

  return (
    <div className="inline-form-card">
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Responsable</label>
          <select name="responsable_user_id" value={form.responsable_user_id} onChange={handleChange}>
            {users.map((u) => (
              <option key={u.id} value={u.id}>
                {u.last_name} {u.first_name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Description</label>
          <textarea name="description" value={form.description} onChange={handleChange} placeholder="Description du To Do..." />
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Échéance</label>
            <input type="date" name="due_date" value={form.due_date} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Statut</label>
            <select name="status" value={form.status} onChange={handleChange}>
              <option value="in_progress">En cours</option>
              <option value="done">Réalisé</option>
            </select>
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Enjeu</label>
            <select name="stake_level" value={form.stake_level} onChange={handleChange}>
              <option value="">—</option>
              <option value="A">A — Fort</option>
              <option value="B">B — Moyen</option>
              <option value="C">C — Faible</option>
            </select>
          </div>
          <div className="form-group">
            <label>Urgence</label>
            <select name="urgency_level" value={form.urgency_level} onChange={handleChange}>
              <option value="">—</option>
              <option value="1">1 — Urgent</option>
              <option value="2">2 — Normal</option>
              <option value="3">3 — Peu urgent</option>
            </select>
          </div>
        </div>
        <div className="form-group">
          <label>Tags</label>
          <TagSelector
            allTags={allTags}
            selectedIds={form.tag_ids}
            onChange={(ids) => setForm({ ...form, tag_ids: ids })}
            onCreateTag={handleCreateTag}
          />
        </div>
        <div className="form-actions">
          <button type="submit" className="btn btn-primary btn-small">Créer le To Do</button>
          <button type="button" className="btn btn-secondary btn-small" onClick={onCancel}>Annuler</button>
        </div>
      </form>
    </div>
  );
}
